import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet/sheet";
import { RoutingGraph } from "./routing";
import { ROUTES } from "@/routes";

export function RoutingSheet() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleOpenChange = useCallback(
    (open: boolean) =>
      void (!open && setTimeout(() => navigate(ROUTES.HOME), 500)),
    [navigate]
  );

  return (
    <Sheet defaultOpen onOpenChange={handleOpenChange}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>{t("routing.title")}</SheetTitle>
        </SheetHeader>
        <div className="p-8 overflow-auto h-[calc(100%-68px)] no-scrollbar">
          <RoutingGraph />
        </div>
      </SheetContent>
    </Sheet>
  );
}
